import { createContext } from 'preact';

/**
 * Context which an ancestor component can use to provide a value for the 'variant' property
 * of the descendant form fields. The context supports the following string literals for its
 * value.
 * 1. 'default'        - this is the default variant of the form control.
 * 2. 'embedded'       - this is when the form component is rendered in core-pack collection
 *                       components and need to take that style.
 * 3. 'legacyEmbedded' - this is when the form component is rendered in legacy collection
 *                       components and need to take that style.
 */
export const FormVariantContext = createContext<
  'default' | 'embedded' | 'legacyEmbedded' | undefined
>('default');
